import { createSlice } from "@reduxjs/toolkit";

const Dashboardslice=createSlice({
    name:'Dashboard',
    initialState:{
        dp1:'Community Solar',
        dp2:'Solar Farms',
        Type:"Commertial",
        Year:2024,
        RoyalSwitch:false,
        RulerSwitch:false,
    },
    reducers:{
        chgdp1:(state,action)=>{
            state.dp1=action.payload
        },
        chgdp2:(state,action)=>{
            state.dp2=action.payload
        },
        chgtype:(state,action)=>{
            state.Type=action.payload
        },
        chgyear:(state,action)=>{
            state.Year=action.payload
        },
        chgRoyalswitch:(state)=>{
            state.RoyalSwitch=!state.RoyalSwitch
        },
        chgRulerswitch:(state)=>{
            state.RulerSwitch=!state.RulerSwitch
        }
    }
})

export const{chgdp1,chgdp2,chgtype,chgyear,chgRoyalswitch,chgRulerswitch}=Dashboardslice.actions
export default Dashboardslice.reducer